import React from "react";
import { toggle } from "../../../../util/common";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const CompanyInformationGroupStructure: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-group-structure-details"
                            onClick={() => toggle("group-structure-details", "btn-group-structure-details")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Group Structure
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Group Structure</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="group-structure-details"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        <div role="grid" className="data-grid row-height-xs " aria-labelledby="officer-details-1">
                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Group
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.group_structure?.group}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Linkages
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.group_structure?.linkages}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Ultimate Holding Company
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.group_structure?.ultimate_holding_company}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company Name
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.group_structure?.company_name}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyInformationGroupStructure;
